import React from "react";
import "./styles.css";
import "./base.css";

import Header from "./Header";
import Home from "./Home/Home";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import Send from "./Send";
import Cotizador from "./Cotizador/Cotizador";
import ABTestDebugger from "./components/ABTestDebugger";
import SeoHead from "./components/SeoHead";

import { IpLocationProvider } from "./context/IpLocationContext";
import LocationBadge from "./components/LocationBadge";

const App = (): JSX.Element => {
    const queryParams = new URLSearchParams(window.location.search);

    if (queryParams.toString()) {
        const params = Object.fromEntries(queryParams.entries());
        try {
            sessionStorage.setItem("queryParams", JSON.stringify(params));
        } catch { }
    }

    return (
        <div className="App">
            <IpLocationProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <SeoHead />
                    <Header />
                    <main id="main-content">
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/cotizador" element={<Cotizador />} />
                            <Route path="/send" element={<Send />} />
                            <Route path="*" element={<Navigate to="/" />} />
                        </Routes>
                    </main>
                    <ABTestDebugger />
                    {/* Demo badge (puede removerse en producción) */}
                    {/* <LocationBadge /> */}
                </BrowserRouter>
            </IpLocationProvider>
        </div>
    );
};

export default App;
